export function sanitizeNameString(name: string): string {
  return name.replace(/(\.|\/|:)/g, '');
}
